import { getText, LanguageService } from 'services/languageService';
import { setCurrentLayerAction } from 'store/actions/layers';
import { setCurrentStatAction } from 'store/actions/mainPage';
import { ISelectedATE, ISelectLayer, IStatDataset } from 'types/mainPage';
import { httpClient, httpConfig } from '../../../utils/httpClient';
import { layersSlice } from '../../../store/reducers/layers';

enum AteType {
  POINT = 'point',
  POLYGON = 'polygon',
}
export type TabType = 'table' | 'pie' | 'bar';

export const getStatQueryParams = (
  ds: IStatDataset | null,
  ateParams: any | undefined,
  curLayer: ISelectLayer | null,
  type: TabType
) => {
  const lang = LanguageService.getLanguage();
  const dataset = String(ds?.id);
  const queryParams = {
    lang,
    dataset,
    type,
  };
  if (curLayer) {
    queryParams['layer'] = String(curLayer.id);
  }

  const { ate_vc, ate_city, ate_reg } = ateParams;

  if (ateParams?.all_1) queryParams['all_1'] = '1';
  if (ateParams?.all_2) queryParams['all_2'] = '1';
  if (ateParams?.all_3) queryParams['all_3'] = '1';

  const allAte = [ate_reg, ate_city, ate_vc];

  allAte.forEach((ate, mainIndex) => {
    const points = ate
      ?.filter((item) => item.type === AteType.POINT)
      .map((item) => String(item.id));

    const polygons = ate
      ?.filter((item) => item.type === AteType.POLYGON)
      .map((item) => String(item.id));

    polygons?.forEach((item, index) => {
      queryParams[`ate_polygons_${mainIndex + 1}[${index}]`] = item;
    });

    points?.forEach((item, index) => {
      queryParams[`ate_points_${mainIndex + 1}[${index}]`] = item;
    });
  });

  return queryParams;
};

export const getAteForBuilding = (
  currentAteRegions: ISelectedATE[],
  currentAteCities: ISelectedATE[],
  currentAteVC: ISelectedATE[]
) => {
  const params: any = {
    ate_vc: [],
    ate_city: [],
    ate_reg: [],
  };

  if (currentAteVC.length) {
    if (currentAteVC[0].id === 'all') {
      params['all_3'] = '1';
    } else {
      params['ate_vc'] = currentAteVC;
    }
  }
  if (currentAteCities.length) {
    if (currentAteCities[0].id === 'all') {
      params['all_2'] = '1';
    } else {
      params['ate_city'] = currentAteCities;
    }
  }
  if (currentAteRegions.length) {
    if (currentAteRegions[0].id === 'all') {
      params['all_1'] = '1';
    } else {
      params['ate_reg'] = currentAteRegions;
    }
  }

  return params;
};

export const setDefaultLayer = (currentDataset, dispatch) => {
  if (!currentDataset || !currentDataset.default_layer) return;
  const defLayer = currentDataset.default_layer;
  dispatch(
    setCurrentLayerAction(
      defLayer.layer,
      defLayer.url,
      defLayer.id,
      defLayer.legend_file,
      defLayer.map_file,
      defLayer.meta_file,
      currentDataset.name,
      defLayer.name,
      defLayer.legend_size,
      defLayer.scale_1_50,
      defLayer.scale_1_50_vector
    )
  );
};

export const resetWmtsLayer = (dispatch) => {
  dispatch(setCurrentLayerAction('', '', 0, '', '', '', '', ''));
};

export const checkExtremeEl = (arr: any[], element: any) => {
  if (arr.length === 0) {
    return false;
  }

  return (
    (element === arr[0] && arr.length === 1) || element === arr[arr.length - 1]
  );
};
export const getLimits = (
  ateVC: any,
  ateCities: any,
  currentAteCities: any,
  currentAteRegions: any,
  tabType: any
) => {
  const limitTab = tabType === 'pie' || tabType === 'bar';

  const disableCitiesLimitsTab =
    limitTab &&
    (!ateCities.length ||
      currentAteRegions.length !== 1 ||
      !!currentAteRegions.find((i) => i.id === 'all'));

  const disableVCLimitsTab =
    limitTab &&
    (!ateVC.length ||
      currentAteCities.length !== 1 ||
      !!currentAteCities.find((i) => i.id === 'all'));

  const citiesTLcond =
    (currentAteRegions.length > 1 ||
      !!currentAteRegions.find((i) => i.id === 'all')) &&
    limitTab;

  const vcTLcond =
    (currentAteCities.length > 1 ||
      !!currentAteCities.find((i) => i.id === 'all')) &&
    limitTab;

  const disableCitiesTables = !ateCities.length || !currentAteRegions.length;

  const disableVcTables = !ateVC.length || !currentAteCities.length;

  const disableCities = limitTab ? disableCitiesLimitsTab : disableCitiesTables;
  const disableVC = limitTab ? disableVCLimitsTab : disableVcTables;

  return {
    disableCities,
    disableVC,
    citiesTLcond,
    vcTLcond,
  };
};

export const checkLimitSelects = (
  tabType: any,
  currentAteRegions: any,
  currentAteCities: any,
  currentAteVC: any,
  dispatch: any
) => {
  const limitTab = tabType === 'pie' || tabType === 'bar';

  if (!limitTab) return;

  const hasMultipleRegions =
    currentAteRegions.length > 1 ||
    !!currentAteRegions.find((i) => i.id === 'all');
  const hasMultipleCities =
    currentAteCities.length > 1 ||
    !!currentAteCities.find((i) => i.id === 'all');

  if (hasMultipleRegions && currentAteCities.length) {
    dispatch(setCurrentStatAction('currentAteCities', []));

    if (currentAteVC.length) {
      dispatch(setCurrentStatAction('currentAteVC', []));
      return;
    }
  }

  if (hasMultipleCities && currentAteVC.length) {
    dispatch(setCurrentStatAction('currentAteVC', []));
  }
};

export const checkPieValidation = (
  currentAteRegions: any[],
  currentAteCities: any[],
  currentAteVC: any[]
) => {
  const allRegions = currentAteRegions.find((i) => i.id === 'all');
  const allCities = currentAteCities.find((i) => i.id === 'all');
  const allVC = currentAteVC.find((i) => i.id === 'all');

  const multipleAte =
    currentAteRegions.length > 1 ||
    currentAteCities.length > 1 ||
    currentAteVC.length > 1;

  const _noOneAll = !(allVC || allCities || allRegions);
  const emptyFields =
    !currentAteVC.length &&
    !currentAteCities.length &&
    !currentAteRegions.length;

  const noOneAll = _noOneAll && !emptyFields;

  let correctRegs: boolean = true;
  let correctCities: boolean = true;
  let correctVC: boolean = true;

  if (allRegions) {
    correctRegs = !currentAteCities.length && !currentAteVC.length;
  }

  if (allCities) {
    correctCities = !currentAteVC.length;
  }

  if (currentAteVC.length) {
    correctVC = !!allVC;
  }

  return { multipleAte, correctRegs, correctCities, correctVC, noOneAll };
};

export const getPieRequirements = (
  currentAteRegions: any,
  currentAteCities: any,
  currentAteVC: any
) => {
  const allRegions = currentAteRegions.find((i) => i.id === 'all');
  const allCities = currentAteCities.find((i) => i.id === 'all');
  const allVC = currentAteVC.find((i) => i.id === 'all');

  const { multipleAte, correctRegs, correctCities } = checkPieValidation(
    currentAteRegions,
    currentAteCities,
    currentAteVC
  );

  return (
    !multipleAte &&
    correctRegs &&
    correctCities &&
    (allVC || allCities || allRegions)
  );
};

export const checkAte = (currentAteVC, currentAteCities, currentAteRegions) => {
  if (currentAteVC.length) {
    return (
      currentAteVC.length !== 1 ||
      !!currentAteVC.find((item) => item.id === 'all')
    );
  } else if (currentAteCities.length) {
    return (
      currentAteCities.length !== 1 ||
      !!currentAteCities.find((item) => item.id === 'all')
    );
  } else if (currentAteRegions.length) {
    return (
      currentAteRegions.length !== 1 ||
      !!currentAteRegions.find((item) => item.id === 'all')
    );
  } else return false;
};

export const checkTransitData = (
  layer: number | any,
  dataset: number | any,
  ateRegion: number | any,
  ateCity: number | any,
  ateVC: number | any
) => {
  const onlyLayer = !ateRegion && !ateVC && !ateCity && layer && dataset;
  const onlyAte = (ateRegion || ateVC || ateCity) && !layer && !dataset;
  const all = (ateRegion || ateVC || ateCity) && layer && dataset;

  return { onlyLayer, onlyAte, all };
};

const URL = process.env.REACT_APP_API_URL;

export const getAteForTransit = async (
  regionAte: any,
  cityAte: any,
  regionType: any,
  cityType: any
) => {
  const allOptions = {
    id: 'all',
    label: getText('SELECT_ALL'),
    name: getText('SELECT_ALL'),
    type: '',
    dataset_name: '',
  };
  let listVC = [];

  const lang = LanguageService.getLanguage();
  const ateUrl = `${URL}/api/listate`;
  const citiesParams = {
    'parent[0]': `${regionAte}_${regionType}`,
    lang,
  };

  const citiesRes = await httpClient.post(
    ateUrl,
    new URLSearchParams(citiesParams),
    httpConfig
  );

  const listAteCities = citiesRes.data.data;
  const _listCities = listAteCities.map((item) => {
    return { ...item, label: item.name };
  });

  const listCities = _listCities.length
    ? [allOptions, ..._listCities]
    : _listCities;

  if (cityAte) {
    const vcParams = { 'parent[1]': `${cityAte}_${cityType}`, lang };

    const vcRes = await httpClient.post(
      ateUrl,
      new URLSearchParams(vcParams),
      httpConfig
    );

    const listAteVC = vcRes.data.data;
    const _listVC = listAteVC.map((item) => {
      return { ...item, label: item.name };
    });

    listVC = _listVC.length ? [allOptions, ..._listVC] : _listVC;
  }

  return { listCities, listVC };
};
